/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrate once with a bank card, then the ruler is accurate on that device forever.`)
};

const es_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibra una vez con una tarjeta bancaria y la regla será precisa en ese dispositivo para siempre.`)
};

const de_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal mit einer Bankkarte kalibrieren, dann ist das Lineal auf diesem Gerät dauerhaft genau.`)
};

const nl_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalibreer eenmalig met een bankpas, en de liniaal is voor altijd nauwkeurig op dat apparaat.`)
};

const fr_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrez une fois avec une carte bancaire, puis la règle reste précise sur cet appareil pour toujours.`)
};

const it_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibra una volta con una carta bancaria, poi il righello resta preciso su quel dispositivo per sempre.`)
};

const pt_br2_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibre uma vez com um cartão bancário e a régua fica precisa naquele aparelho para sempre.`)
};

const pt_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibre uma vez com um cartão bancário e a régua fica rigorosa nesse dispositivo para sempre.`)
};

const ja_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銀行カードで一度校正すれば、その端末では以降ずっと正確に使えます。`)
};

const zh_ruler_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用银行卡校准一次，此后该设备上的标尺将永久准确。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_ex1", locale)
	if (locale === "en") return en_ruler_ex1(inputs)
	if (locale === "es") return es_ruler_ex1(inputs)
	if (locale === "de") return de_ruler_ex1(inputs)
	if (locale === "nl") return nl_ruler_ex1(inputs)
	if (locale === "fr") return fr_ruler_ex1(inputs)
	if (locale === "it") return it_ruler_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_ex1(inputs)
	if (locale === "pt") return pt_ruler_ex1(inputs)
	if (locale === "ja") return ja_ruler_ex1(inputs)
	return zh_ruler_ex1(inputs)
};